// extracted by mini-css-extract-plugin
module.exports = {"col":"styles_col__3AVli","active":"styles_active__3na8q","title":"styles_title__2m5jB","withKey":"styles_withKey__2Q-hS"};